export interface GoalReviewVisibility {
  criteriaSetName: string | null
  isGoalCustomized: boolean
  isAiFeatureVisible: boolean
  goalUuid: string | null | undefined
  hasReviewCriteria: boolean
}

export function shouldShowGoalReview({
  criteriaSetName,
  isGoalCustomized,
  isAiFeatureVisible,
  goalUuid,
  hasReviewCriteria,
}: GoalReviewVisibility): boolean {
  const hasNamedCriteriaSet = Boolean(criteriaSetName)
  const isReviewableCustomization = !isGoalCustomized || hasNamedCriteriaSet
  const hasGoalToReview = Boolean(goalUuid)
  return isReviewableCustomization && isAiFeatureVisible && hasGoalToReview && hasReviewCriteria
}
